import { render, staticRenderFns } from "./GiftBenefitRecord.vue?vue&type=template&id=c7c72c00&scoped=true&"
import script from "./GiftBenefitRecord.vue?vue&type=script&lang=js&"
export * from "./GiftBenefitRecord.vue?vue&type=script&lang=js&"
import style0 from "./GiftBenefitRecord.vue?vue&type=style&index=0&id=c7c72c00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c72c00",
  null
  
)

export default component.exports